/* eslint-disable no-prototype-builtins */
/* eslint-disable react/no-unescaped-entities */

import React from 'react'
import axios from 'axios'

// mui
import Box from '@mui/material/Box'

import { standardButton } from './buttons'
import { uploadImageDimension, videoDimension, maximumVideoDuration, pinturaAudioBitrate, pinturaVideoBitrate, videoFramesPerSecond } from './variableDefaults'

/* eslint-disable camelcase */
import { PinturaEditor } from '@pqina/react-pintura'
import '@pqina/pintura/pintura.css'
import { 
  processImage,
  getEditorDefaults,
  createNode,
  appendNode,
  findNode
} from '@pqina/pintura'
import {
  // editor
  createDefaultImageReader,
  createDefaultShapePreprocessor,
  createDefaultImageWriter,
  createDefaultMediaWriter,
  imageStateToCanvas,

  // plugins
  setPlugins,
  plugin_crop,
  plugin_finetune,
  plugin_finetune_defaults,
  plugin_filter,
  plugin_filter_defaults,
  plugin_annotate,
  markup_editor_defaults
} from '@pqina/pintura'

import '@pqina/pintura-video/pinturavideo.css'
import {
  plugin_trim_locale_en_gb,
  plugin_trim,
  createDefaultVideoWriter,
  createMediaStreamEncoder
} from '@pqina/pintura-video'

import {
  LocaleCore,
  LocaleCrop,
  LocaleFinetune,
  LocaleFilter,
  LocaleAnnotate,
  LocaleMarkupEditor
} from '@pqina/pintura/locale/en_GB'

setPlugins(plugin_trim, plugin_crop)


export const pinturaEditorDefaults = (imageOrVideo = 'image', trimCropIndex = 0) => {
  
  return getEditorDefaults({
    locale: {
      // Add the Trim plugin locale
      ...plugin_trim_locale_en_gb,
    },
    // utils: imageOrVideo === 'image' ? ['crop'] : ['trim', 'crop'],
    enableUtils: false,
    enableToolbar: false,
    // enableButtonExport: false,
    enableButtonRevert: false,
    enableNavigateHistory: false,
    enableZoomControls: false,
    enableZoom: (imageOrVideo === 'video' && trimCropIndex === 0) ? false : false,
    enablePan: (imageOrVideo === 'video' && trimCropIndex === 0) ? false : true,
    // zoomLevel: null,

    util: (imageOrVideo === 'video' && trimCropIndex === 0) ? 'trim' : 'crop',
    layoutDirectionPreference: 'vertical',
    layoutVerticalUtilsPreference: 'bottom',
    layoutVerticalToolbarPreference: 'bottom',
    imageWriter: createDefaultMediaWriter(
      // Generic Media Writer options, passed to image and video writer
      {
        targetSize: {
          width: imageOrVideo === 'image' ? uploadImageDimension : videoDimension,
        },
      },
      [
        // For handling images
        createDefaultImageWriter(),

        // For handling videos
        createDefaultVideoWriter({
          // Video writer instructions here
          // ...

          // Encoder to use
          encoder: createMediaStreamEncoder({
            imageStateToCanvas,

            // output quality (optional)
            videoBitrate: pinturaVideoBitrate, // .85MBps
            audioBitrate: pinturaAudioBitrate, // 192KBps

            // Default FPS (optional)
            framesPerSecond: videoFramesPerSecond,
          }),
        })
      ]
    ),
  })
}

export const pinturaEditorJSX = (editorRef, srcMedia, aspectRatio, mediaType, trimCropIndex, handleSavePressed) => {
  return (
    <PinturaEditor
      ref={editorRef}

      {...pinturaEditorDefaults(mediaType, trimCropIndex)}
      
      src={srcMedia}
      
      // Crop Plugin
      imageCropAspectRatio={aspectRatio}
      cropEnableButtonFlipHorizontal={false}
      cropEnableButtonRotateLeft={false}
      cropEnableRotationInput={false}
      cropEnableCenterImageSelection={false}
      cropAutoCenterImageSelectionTimeout={200}
      // cropEnableZoom={false}

      // Trim Plugin
      trimEnableSplit={false}
      imageMaxDuration={maximumVideoDuration}

      // Export Button
      enableButtonExport={false}

      // Load and Process
      onLoad={(res) => console.log('load media', res)}
      onProcess={({ dest }) => dest && handleSavePressed(dest)}
    />
  )
}